import styles from "../styles/profile.module.scss";
import Button from "../../../components/shared/Button/Button";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/routes";
const CardAddedModal = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={styles.addCardModalWrapper}>
      <div className={styles.addCardModalTextContent}>
        <div className={styles.addCardModalTitle}>{t("cardAdded")}</div>
        <div className={styles.addCardModalDescr}>{t("chooseYourSub")}</div>
      </div>
      <Button title={t("chooseSub")} submit={() => navigate(ROUTES.DISCOUNT)} className={styles.addCardModalSubmit} />
    </div>
  );
};

export default CardAddedModal;
